import React from 'react'
import { Box } from 'rebass/styled-components'

const Divider = () => {
  return (
    <Box
      height="1px"
      maxWidth="container"
      mx={[5, 5, 'auto']}
      bg="darkBlue"
      sx={{
        opacity: 0.1
      }}
    />
  )
}

export default Divider
